export default __webpack_public_path__ + "static/media/img-not-found.47d2f176.svg";